<div class="row mt-5 justify-content-center">
  <div class="col-lg-8 col-md-10 col-sm-12">
    <div class="text-center">
      <h2 class="fw-bold text-black my-4">Confirmación de cuenta</h2>
    </div>
    <form>
      <div class="row justify-content-center">
        <div class="col-md-6 col-sm-12  text-center">
          <h3 class="text-secondary">{{title}}</h3>
          <p class="text-light">{{body}}</p>
        </div>
      </div>
      <div class="row" *ngIf="showResendConfirmationEmailButton">
        <div class="col text-center">
          <button class="btn btn-primary" (click)="resendConfirmationEmail()">Reenviar correo de confirmación</button>
        </div>
      </div>
      <div class="d-grid gap-2">
        <button type="submit" class="btn btn-primary py-3 btn-block" (click)="navigateToHome()">Acceder</button>
      </div>
    </form>
  </div>
</div>